import DesktopHeader from './DesktopHeader';
import MobileHeader from './MobileHeader';
import useMediaQuery from '@mui/material/useMediaQuery';

const Header = () => {

    const isDesktopOrLaptop = useMediaQuery('(min-width:1224px)');

    if (isDesktopOrLaptop) {
        return <DesktopHeader />
    }

    return <MobileHeader />
}

export default Header;